import ability from '../ability'

export const updatePermissions = (permissions) => {
  const permissionSetArr = []
  permissions.forEach(permission => {
    const permissionSplit = permission.split(' ')
    permissionSetArr.push({ actions: permissionSplit[0], subject: permissionSplit[1] })
  })
  ability.update(permissionSetArr)
}
